import { AsyncComponentRender } from '@components/AsyncComponent';
import { createTabs } from '@packages/tabs';

export const TABS = createTabs([['products', null, AsyncComponentRender(() => import('./Products'))]]);
